<template>
    <!-- 总平台管理－预约库存-->
    <div>
        <content-view v-show="$utils.renderWhen(this,'orderInventory')">
            <div class="orderInventory" v-if="shopId != -1">
                <div id="components-layout-demo-basic">
                    <a-layout>
                        <a-layout-sider>
                            <inventory-list></inventory-list>
                        </a-layout-sider>
                        <a-layout>
                            <div class="cj_calendar">
                                <a-row class="cj_row">
                                    <a-col :span="5" class="text-left">
                                        <span @click="pickerBtns()" class="text-primary ml8 mr8 point" style="font-size:24px;position:relative;top:3px;"><a-icon type="left-circle" theme="filled" /></span>
                                        <a-month-picker style="width: 105px" format="YYYY-MM" v-model="pickerDate" :allowClear="false"></a-month-picker>
                                        <span @click="pickerBtns(1)" class="text-primary ml8 point" style="font-size:24px;position:relative;top:3px;"><a-icon type="right-circle" theme="filled" /></span>
                                    </a-col>
                                    <a-col :span="19" class="text-right">
										<router-link :to="{name:'inventoryItemManage',query:{id:id}}">
                                            <a-button class="mr8" type="primary">库存项目管理</a-button>
                                        </router-link>
                                        <router-link v-if="getBtnByAuth('createInventory')" :to="{name:'createInventory',query:{id:id}}">
                                            <a-button class="mr8" type="primary">批量生成预约库存</a-button>
                                        </router-link>
                                        <router-link v-if="getBtnByAuth('amendScreening')" :to="{name:'amendScreening',query:{id:id}}">
                                            <a-button class="mr8" type="primary">批量修改场次时间</a-button>
                                        </router-link>
                                        <router-link v-if="getBtnByAuth('amendInventory')" :to="{name:'amendInventory',query:{id:id}}">
                                            <a-button class="mr8" type="primary">批量修改场次库存</a-button>
                                        </router-link>
                                        <router-link  :to="{name:'closeInventory',query:{id:id}}">
                                            <a-button class="mr8" type="primary">批量关闭场次库存</a-button>
                                        </router-link>
                                    </a-col>
                                </a-row>
                                <div class="calendar-content">
                                    <div class="calendar-content-loading-content" v-show="spinShow">
                                        <a-spin></a-spin> 
                                    </div>
                                    <a-calendar :value="pickerDate" class="totalPlatCalender mt32">
                                        <template slot="dateFullCellRender" slot-scope="value">
                                            <div class="ant-fullcalendar-date">
                                                <div class="ant-fullcalendar-value"><span class="float-left">{{value.format("YYYY-MM-DD") | lunarDate}}</span><span>{{value.date()}}日</span></div>
                                                <div class="ant-fullcalendar-content">
													<ul class="events">
														<li v-for="item in getListData(value)" :key="item.id">
															<a-tooltip>
																<template slot='title'>
																	<div class="font-nowrap">
																		<div>{{value.format("LL")}} {{item.reserveStockPeriodType}}</div>
																		<div>
																			{{item.startTime ? item.startTime.substr(0,5) : ''}}
																			-
																			{{item.endTime ? item.endTime.substr(0,5) : ''}}
																			余 {{item.capacity - item.reserveNum - item.forceReserveNum}}
																			已预约 {{item.reserveNum}}
																			强制预约 {{item.forceReserveNum}}
																		</div>
																	</div>
																</template>
																<span @click="openEdit(item)" :disabled="!(item.capacity - item.reserveNum - item.forceReserveNum) || item.isClose" class="eventText">{{item.startTime ? item.startTime.substr(0,5) : ''}}-{{item.endTime ? item.endTime.substr(0,5) : ''}} 余{{item.capacity - item.reserveNum - item.forceReserveNum}}</span>
															</a-tooltip>
														</li>
													</ul>
                                                </div>
                                            </div>
                                        </template>
                                    </a-calendar>
                                </div>
                            </div>
                        </a-layout>
                    </a-layout>
                </div>
            </div>
			<a-empty class="pt24 pb24" v-else >
				<span slot="description" class="font-big22">请切换到各门店查看</span>
			</a-empty>
        </content-view>
        <router-view></router-view>
		<a-modal
            title="修改场次库存"
            :visible="visible"
            @ok="handleOk"
            :confirmLoading="confirmLoading"
			:destroyOnClose="true"
			:okButtonProps="{props: {disabled: spinning || currentPeriodDetail.isClose}}"
            @cancel="handleCancel"
			width="600px"
        >
			<a-spin :spinning="spinning">
				<a-form :form="periodForm" class="store-one-form">
					<a-form-item label="场次" :labelCol="{span: 6}" :wrapperCol="{span: 18}" class="text-left">
						<a-select :disabled="currentPeriodDetail.isClose || !getBtnByAuth('amendInventory')" :options="storeTypes" v-decorator="['periodTypeId']" style="width: 30%" @change="storeTypeChange"></a-select>
						<span class="pl24"></span>
						<a-input style="width:28%" placeholder="请选择场次类型" disabled v-decorator="['startTime']">
						</a-input>
						至
						<a-input style="width:28%" placeholder="请选择场次类型" disabled v-decorator="['endTime']">
						</a-input>
					</a-form-item>
					<a-form-item label="今日总库存数量" :label-col="{span: 6}" :wrapper-col="{span: 18}">
						<a-input :disabled="currentPeriodDetail.isClose || !getBtnByAuth('amendInventory')" placeholder="请输入" v-decorator="['capacity']"></a-input>
					</a-form-item>
					<a-form-item label="当前剩余库存数量" :label-col="{span: 6}" :wrapper-col="{span: 18}">					
						<span>{{currentPeriod.capacity - currentPeriod.reserveNum - currentPeriod.forceReserveNum}}</span>
						<span class="ml24 mr24">已预约：{{currentPeriod.reserveNum}}</span>
						<span class="ml24 mr24">强制预约：{{currentPeriod.forceReserveNum}}</span>
						<span><a class="text-primary" @click="exportExcel()">导出预约名单</a></span>					
					</a-form-item>
					<a-form-item label="是否关闭该场次" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
						<a-radio-group
						name="state"
						:disabled="currentPeriodDetail.isClose || !getBtnByAuth('amendInventory')"
						@change="onChangeClose"
						v-decorator="['isClose']"
						>
							<a-radio :value="0">否</a-radio>
							<a-radio :value="1">是</a-radio>
						</a-radio-group>
					</a-form-item>
					<a-form-item label="短信通知已预约用户" v-if="isClose" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
						<a-radio-group
							name="sendState"
							:disabled="currentPeriodDetail.isClose || !getBtnByAuth('amendInventory')"
							@change="onChangeInfo"
							v-decorator="['isSendMessage']"
						>
							<a-radio :value="0">否</a-radio>
							<a-radio :value="1">是</a-radio>
						</a-radio-group>
					</a-form-item>
					<a-form-item label="短信内容" v-if="isSendMessage" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
						<a-textarea 
						placeholder="最多输入150个字符" 
						:maxLength="150" 
						:autosize="{ minRows: 3, maxRows: 8 }"
						:disabled="currentPeriodDetail.isClose || !getBtnByAuth('amendInventory')"
						@change="onChangeText" 
						v-decorator="['message', {rules: [{required: true, message: '请输入发送的短信内容'}]}]"
						></a-textarea>
						<span>{{lengthTips}}/150</span>
					</a-form-item>
				</a-form>
			</a-spin>
            
        </a-modal>
    </div>
</template>

<script type="text/javascript">
import inventoryList from "@/components/modules/platform/Inventory.list.component";
import lunarDate from "@/plugins/lunar-date";
import moment from "moment";
import { mapGetters } from "vuex"
export default {
	name: "orderInventory",
	components: { inventoryList },
	props: {},
	data() {
		return {
			visible: false,
			openKeys: ["3"],
			id: undefined,
			moment,
			pickerDate: moment(),
			calendarData: [],
			spinShow: false,
			confirmLoading: false,
			currentPeriod: {},
			storeTypes: [],
			isClose: false,
			isSendMessage: false,
			remain: '',
			lengthTips: 0,
			currentPeriodDetail: {},
			spinning: false
		};
	},
	computed: {
		...mapGetters(["currentItem", "currnetId", "shopId"])
	},
	filters:{
		/**
		 * @lunarDate {filters}  获取农历
		 * @date {string:"yyyy-mm-dd"}
		 */
			lunarDate (date) {
				var dataArr = date.split("-");
				return lunarDate.solar2lunar(dataArr[0],dataArr[1],dataArr[2]).IDayCn;
			}
	},
	methods: {
		getMessage() {
			this.$message.warn("请切换到各门店查看");
		},
		/**
		 *@getListData {method} 添加日历事件
		*/
		getListData(value) {
			let currentItem = this.calendarData.find(item => value.format("YYYY-MM-DD") === item.date);
			return currentItem && currentItem.periodVos ? currentItem.periodVos : [];
		},
		/**
		 *@pickerBtns {method} 日历月份切换
		*/
		pickerBtns (type) {
			if(type){
				this.pickerDate = moment(this.pickerDate).add(1,"month")
			}else{
				this.pickerDate = moment(this.pickerDate).subtract(1,"month")
			}
		},
		/**
		 *@getDateStore {method} 获取当月日历事件 若无库存项目则返回空日历
		*/
		getDateStore () {
			if(String(this.shopId) == '-1' || !this.shopId){
				this.calendarData = [];
				return false;
			}
			this.spinShow = true;
			if(!this.currnetId) {
				this.calendarData = [];
				this.spinShow = false;
				return false
			}
			this.$api.totalPlatform.getDateStore({
				body: {
					reserveStockId: this.currnetId,
					endDate: this.pickerDate.endOf("month").format("YYYY-MM-DD"),
					startDate: this.pickerDate.startOf("month").format("YYYY-MM-DD")
				},
			}).then(res => {
				this.calendarData = res;
				this.spinShow = false;
			});
		},
		/**
		 *@getStorePeriodDetail {method} 获取关闭库存场次后的回显
		*/
		getStorePeriodDetail () {
			this.spinning = true;
			this.$api.totalPlatform.getPeriodById({
				params:{
					periodId: this.currentPeriod.id,
				}
			}).then(res => {
				this.spinning = false;
				this.currentPeriodDetail = res;
				this.isClose = res.isClose;
				this.isSendMessage = res.isSendMessage;
				this.periodForm.setFieldsValue({
					periodTypeId: res.periodTypeId,
					startTime: res.startTime,
					endTime: res.endTime,
					capacity: res.capacity,
					isClose: Number(res.isClose),
				});
				if (res.isClose) {
					this.$nextTick(() => {
						this.periodForm.setFieldsValue({
							isSendMessage: Number(res.isSendMessage),
							message: res.message
						});
					});
				}
			});
		},
		openEdit (item) {
			this.currentPeriod = item;
			this.visible = true;
			this.getStorePeriodDetail();
		},
		//是否关闭场次
		onChangeClose(e){
			this.isClose = Boolean(e.target.value);
		},
		onChangeInfo(e){
			this.isSendMessage = Boolean(e.target.value);
		},
		//文本域内容变化
		onChangeText(e){
			this.lengthTips = e.target.value.length;
		},
		//导出预约名单
		exportExcel(){
			var periodId = parseInt(this.currentPeriod.id);
			this.$api.totalPlatform.exportReserveRecord({
				query: {
					periodId: periodId
				}
			})
			.then(res => {
				let a = document.createElement("a");
				
				a.setAttribute("href", res);
				a.click();
			});
		},
		handleOk () {
			this.periodForm.validateFields((err,values) => {
				if(!err){
					values.message = values.isSendMessage ? values.message : ''
					this.confirmLoading = true;
					this.$api.totalPlatform.updatePeriod({
						body: {
							...values,
							reserveStockPeriodType: this.currentPeriod.reserveStockPeriodType,
							reserveStockPeriodId: this.currentPeriod.id,
							capacity: this.currentPeriod.capacity,
							stockNum: values.capacity,
							isSendMessage: Boolean(values.isSendMessage),
							isClose: Boolean(values.isClose),
						}
					}).then( res => {
						this.visible = false;
						this.confirmLoading = false;
						this.$message.success("修改成功！");
						this.getDateStore();
						this.periodForm.resetFields();
						this.isClose = false;
						this.isSendMessage = false;
					}).catch(err => {
						this.confirmLoading = false;
					})
				}
			})
		},
		handleCancel () {
			this.periodForm.resetFields();
			this.visible = false;
			this.isClose = false;
			this.isSendMessage = false;
			this.lengthTips = 0;
			this.currentPeriodDetail = {};
		},
		/**
		*@storeTypeChange 场次类型选择
		*/
		storeTypeChange (value) {
			let currentPeriod = this.storeTypes.find(i => i.id === value);
			this.periodForm.setFieldsValue({ startTime: currentPeriod.startTime, endTime: currentPeriod.endTime });
		},
		/**
		 * @getStoreTypes {method} 获取所有场次类型
		 */
		getStoreTypes () {
			if (String(this.shopId) === '-1') {
				return false;
			}
			this.$api.totalPlatform.storeTypes({
				params:{ 
					shopId: this.shopId
				}
			}).then(res => {
				res.forEach(i => {
					i.value = i.id;
					i.label = i.name;
				});
				this.storeTypes = res;
			})
		},
	},
	watch: {
		pickerDate (){
			this.getDateStore();
		},
		currnetId (val) {
			this.pickerDate = moment();
			this.getDateStore();
		},
		shopId (val) {
			if (val) {
				this.id = val;
				this.getDateStore();
				this.getStoreTypes();
			}
		},
		$route (to,from) {
			if (to.name === 'orderInventory') {
				this.getDateStore();
			}
		},
		isClose(newval,oldval){
			if(!newval){
				this.isSendMessage = false
			}
		}
	},
	beforeCreate () {
		this.periodForm = this.$form.createForm(this);
	},
	created() {},
	mounted() {
		this.id = this.shopId;
		this.getDateStore();
		if (this.shopId) {
			this.getStoreTypes();
		}
	}
};
</script>
<style lang="scss">
	.orderInventory {
		background-color: #fff;
		padding: 24px 32px;
		border-radius: 2px;
		user-select: none;
	.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value, .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value{
		color: rgba(0, 0, 0, 0.65);
	}
	.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {
		background: #fff;
	}
	.calendar-content{
		position: relative;
		&-loading-content{
			position: absolute;
			left:0;
			top:0;
			right:0;
			bottom:0;
			background: rgba(255, 255, 255, .6);
			z-index: 99;
			display: -webkit-box;
			display: -ms-flexbox;
			display: -webkit-flex;
			display: flex;
			-webkit-box-pack: center;
			-ms-flex-pack: center;
			-webkit-justify-content: center;
			justify-content: center;
			-webkit-box-align: center;
			-ms-flex-align: center;
			-webkit-align-items: center;
			align-items: center;
		}
	}
	}
	#components-layout-demo-basic {
		text-align: center;
		border: 1px solid rgba(233, 233, 233, 1);
		background: #fff;
	}
	#components-layout-demo-basic .ant-layout-header,
	#components-layout-demo-basic .ant-layout-footer {
		background: #7dbcea;
		color: #fff;
	}
	#components-layout-demo-basic .ant-layout-footer {
		line-height: 1.5;
	}
	#components-layout-demo-basic .ant-layout-sider {
		background: #fff;
		color: #000000;
		font-size: 16px;
	.title {
		line-height: 60px;
		border: 0;
		border-bottom: 1px solid rgba(233, 233, 233, 1);
		a {
			color: $text-color-primary;
		}
	}
	}
	#components-layout-demo-basic .ant-layout-content {
		background: rgba(16, 142, 233, 1);
		color: #fff;
	}
	#components-layout-demo-basic > .ant-layout {
		margin-bottom: 48px;
	}
	#components-layout-demo-basic > .ant-layout:last-child {
		margin: 0;
	}
	.cj_calendar {
		background: #fff;
		border-left: 1px solid rgba(233, 233, 233, 1);
	.cj_row {
		line-height: 50px;
		font-size: 20px;
		font-weight: 500;
		color: rgba(0, 0, 0, 0.85);
	}
	}
	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	.eventText{
		color: #FF6D33;
		background: rgba(245, 127, 37,.1);
		padding: 5px;
		border-radius: 6px;
		display: block;
		margin-top:8px;
		font-size: 10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		&[disabled]{
			color: rgba(0, 0, 0, 0.24);
			background: rgba(0, 0, 0, 0.06);
		}
	}
	}
	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}
	.notes-month {
		text-align: center;
		font-size: 28px;
	}
	.notes-month section {
		font-size: 28px;
	}
	.totalPlatCalender{
		.ant-fullcalendar-header{
			display: none;
		}
	}
</style>